import React from 'react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  href,
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <a href={href} target={href.startsWith('#') || href.startsWith('/') ? undefined : '_blank'} rel={href.startsWith('#') || href.startsWith('/') ? undefined : 'noopener noreferrer'} onClick={onClick} className={`group relative inline-flex items-center justify-center font-bold text-white bg-gradient-to-r from-[#F4A261] to-[#FFD166] rounded-2xl overflow-hidden transition-all hover:scale-[1.02] hover:brightness-105 shadow-[0_14px_34px_rgba(244,162,97,0.28)] hover:shadow-[0_18px_40px_rgba(244,162,97,0.35)] focus:outline-none focus:ring-4 focus:ring-[#F4A261]/40 px-8 py-4 ${className}`} data-id="element-271">
      <span className="relative" data-id="element-272">{children}</span>
    </a>;
}